import {Controller} from "stimulus";
import 'jquery-ui-sortable-npm'

export default class extends Controller {
    static targets = ['image']

    connect() {
        this.urlAdd = this.element.dataset.urlAdd;
        this.urlRemove = this.element.dataset.urlRemove;
        this.selected = this.element.dataset.selected || 0;
        this.imageOn = this.element.dataset.imageOn;
        this.imageOff = this.element.dataset.imageOff;
        this.dataLayerContext = this.element.closest('.product-item')?.dataset.list;

        this.updateImage(this.selected);

    }

    updateImage(isSelected) {
        if (isSelected) {
            this.imageTarget.src = this.imageOn;
        } else {
            this.imageTarget.src = this.imageOff;
        }
    }

    change(event) {
        event.preventDefault();
        if (this.selected) {
            this.removeFavorite();
        } else {
            this.addFavorite();
        }
    }


    addFavorite() {
        this.selected = 1;
        this.updateImage(true);
        this.buildAjax(this.urlAdd, 'add');
    }

    removeFavorite() {
        this.selected = 0;
        this.updateImage(false);
        this.buildAjax(this.urlRemove, 'remove');
    }

    buildAjax(url, intention) {
        let _self = this
        $.ajax({
            data: null,
            url: url,
            method: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            success: function (result) {
                _self.successAjax(_self, result, intention)
            },
        });
    }

    successAjax(_self, result, intention) {

        if (!result.success === true) {
            return;
        }

        if (intention === 'add') {
            const product = JSON.parse(result.product);

            EventManager.fire('favorite-added', result.product);
            EventManager.fire(`favorite-added-gtm-context`, {
                context: this.dataLayerContext,
                productId: product.id,
            });
        } else {
            EventManager.fire('favorite-removed');
            if(window.location.href.includes("/wishlist")){
                window.location.reload();
            }
        }
    }
}
